module.exports = __webpack_public_path__ + "static/img/chuzhonghuaxue.997b327a.jpg";